import React from 'react'

const DepositPayment = ({ franchisePaymentPlan }) => (
  <li>
    At Booking: { franchisePaymentPlan.attributes.depositAmountFormatted } ({ franchisePaymentPlan.attributes.depositTerm })
  </li>
)

export default DepositPayment
